import React from 'react'

const TimedMetadataContext = React.createContext({})

export default TimedMetadataContext